export const iconFontAwesomeHumanitarianWifi = (
	<i className="fa-solid fa-wifi"></i>
);
